if (!customElements.get('mega-menu-quick-add')) {
    const loaderScript = document.currentScript;
    const ensureProductForm = () => {
        if (customElements.get('product-form')) return;
        if (document.querySelector('script[src*="/product.js"]')) return;
        const src = loaderScript && loaderScript.dataset.productJs;
        if (!src) return;
        const script = document.createElement('script');
        script.src = src;
        script.defer = true;
        document.head.appendChild(script);
    };

    class MegaMenuQuickAdd extends HTMLElement {
        connectedCallback() {
        if (this._ready) return;
        this._ready = true;
        this.button = this.querySelector('.mega-menu-quick-add__button');
        this.options = this.querySelector('.mega-menu-quick-add__options');

        this.addEventListener('click', this.onClick.bind(this));
        this.addEventListener('keydown', this.onKeydown.bind(this));
        }

        onClick(event) {
        const option = event.target.closest('.mega-menu-quick-add__option');
        if (option) {
            event.preventDefault();
            event.stopPropagation();
            if (!option.disabled) this.add(option.dataset.variantId, option);
            return;
        }

        const button = event.target.closest('.mega-menu-quick-add__button');
        if (!button) return;

        // Several options: the theme's <quick-view> handles the click (opens the product drawer).
        if (button.tagName === 'QUICK-VIEW') {
            ensureProductForm();
            this.closeMobileMenuWhenCartOpens();
            return;
        }

        event.preventDefault();
        event.stopPropagation();
        if (button.disabled) return;

        if (this.options) {
            this.toggleOptions();
        } else {
            this.add(button.dataset.variantId, button);
        }
        }

        onKeydown(event) {
        if (event.key === 'Escape' && this.isOpen()) {
            this.toggleOptions(false);
            this.button.focus();
            return;
        }
        // <quick-view> is not a native button: support Enter / Space.
        if ((event.key === 'Enter' || event.key === ' ') && event.target.tagName === 'QUICK-VIEW') {
            event.preventDefault();
            event.target.click();
        }
        }

        isOpen() {
        return this.classList.contains('is-open');
        }

        toggleOptions(force) {
        if (!this.options) return;
        const open = typeof force === 'boolean' ? force : !this.isOpen();
        this.classList.toggle('is-open', open);
        this.options.hidden = !open;
        this.button.setAttribute('aria-expanded', String(open));

        if (open) {
            const first = this.options.querySelector('.mega-menu-quick-add__option:not([disabled])');
            if (first) first.focus({ preventScroll: true });
            this._outside = (e) => {
            if (!this.contains(e.target)) this.toggleOptions(false);
            };
            document.addEventListener('click', this._outside);
        } else if (this._outside) {
            document.removeEventListener('click', this._outside);
            this._outside = null;
        }
        }

        add(variantId, trigger) {
        const card = this.closest('product-card');
        if (!variantId || !card || typeof card.addToCart !== 'function') return;

        this.closeMobileMenuWhenCartOpens();
        if (this.options) {
            document.addEventListener('cart:item-added', () => this.toggleOptions(false), { once: true });
        }
        // Theme flow: add to cart, refresh cart drawer + count, open the cart drawer.
        card.addToCart(variantId, trigger);
        }

        // On mobile the menu is a full-screen drawer: close it once the cart drawer opens.
        closeMobileMenuWhenCartOpens() {
        if (!this.closest('#mobile-menu')) return;
        const onCartOpen = () => {
            clearTimeout(timer);
            const toggle = document.querySelector('.mobile-toggle-wrapper');
            if (toggle && toggle.classList.contains('active')) {
            toggle.querySelector('.mobile-toggle')?.click();
            }
        };
        const timer = setTimeout(() => document.removeEventListener('cart-drawer:open', onCartOpen), 5 * 60 * 1000);
        document.addEventListener('cart-drawer:open', onCartOpen, { once: true });
        }
    }

    customElements.define('mega-menu-quick-add', MegaMenuQuickAdd);
}